import { createApi } from '@reduxjs/toolkit/query/react';
import axiosBaseQuery from '../../utils/axiosBaseQuery';
import { serializeQueryArgsWithTenant } from '../tenantCacheKey';

interface ProfileInfo {
    name: string;
    sub: string;
    nickname: string;
    email: string;
    picture: string;
}

interface UpdateIssueReportRequest {
    id: string;
    comment: string;
    state: string;
    profileInfo: ProfileInfo;
}

export const issueReportApi = createApi({
    reducerPath: 'issueReportApi',
    serializeQueryArgs: serializeQueryArgsWithTenant,
    baseQuery: axiosBaseQuery(),
    endpoints: (builder) => ({
        updateIssueReport: builder.mutation<any, UpdateIssueReportRequest>({
            query: ({ id, comment, profileInfo, state }) => ({
                url: `damage-reports/${id}`,
                method: 'POST',
                data: { comment, profileInfo, state },
            }),
        }),
        // Add other endpoints here as needed
    }),
});

export const {
    useUpdateIssueReportMutation,
} = issueReportApi;
